<script setup lang="ts">
import LoaderSpinner from "../LoaderSpinner.vue";

defineProps<{
	loading: boolean;
}>();

const emit = defineEmits<{ (e: "close-modal"): unknown }>();
</script>

<template>
	<Teleport to="body">
		<div class="modal-overlay">
			<div class="modal-box">
				<div v-if="loading" class="modal-loading">
					<div class="spinner-wrap">
						<LoaderSpinner />
					</div>
				</div>

				<div v-else class="modal-content">
					<slot />
					<div class="center-button">
						<button class="btn" @click="emit('close-modal')">Ok</button>
					</div>
				</div>
			</div>
		</div>
	</Teleport>
</template>

<style scoped lang="scss">
.modal-overlay {
	position: fixed;
	inset: 0;
	z-index: 1000;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(0, 0, 0, 0.5);
}

.modal-box {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	max-width: 520px;
	min-height: 400px;
	padding: 24px;
	box-sizing: border-box;
	border-radius: 12px;
	background: #fff;
}

.modal-close {
	position: absolute;
	top: 12px;
	right: 12px;
	border: none;
	background: transparent;
	font-size: 22px;
	cursor: pointer;
}

.modal-loading {
	display: flex;
	align-items: center;
	justify-content: center;
}

.spinner-wrap {
	width: 60px;
	height: 60px;
}

.spinner-wrap :deep(.loader) {
	transform: scale(0.15);
	transform-origin: center;
}

.modal-content {
	width: 100%;
}
.center-button {
	width: 100%;
	display: flex;
	justify-content: center;
	.btn {
		background-color: $app-color;
	}
}
</style>
